<template functional>
  <tr>
    <slot name="cellInfo" v-bind="props.item" />
    <td
      v-for="(cell, i) in props.item.rowCells"
      :key="i"
      :class="[
        cell.isWeekend ? 'weekend' : '',
        `cell-${props.eventIndex}-${i + 1}`,
        'cell'
      ]"
    >
      <div
        v-if="cell.used"
        :class="`cell-${props.eventIndex}-${i + 1}`"
        @mouseenter="
          listeners['block-over'](`.cell-${props.eventIndex}-${i + 1}`)
        "
        @mouseleave="listeners['block-out']()"
      >
        <router-link
          :to="$options.linkToEvent(injections, props.item.event)"
          :class="
            `event-date-block ${props.item.event.discipline.name} d-block`
          "
        />
      </div>
    </td>
  </tr>
</template>
<script>
export default {
  name: "GanttEventRow",
  inject: {
    isNoncompetition: {
      default: false
    }
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    eventIndex: {
      type: Number,
      required: true
    }
  },
  linkToEvent(injections, event) {
    if (injections.isNoncompetition) {
      return {
        name: "NoncompetitionEventProfilePage",
        params: { eventId: event.id }
      };
    }
    if (["results_published", "closed", "archived"].includes(event.status)) {
      return { name: "EventResultsPage", params: { eventId: event.id } };
    } else {
      return { name: "EventProfilePage", params: { eventId: event.id } };
    }
  }
};
</script>

<style scoped>
.weekend {
  background-color: rgba(233, 238, 250, 0.4) !important;
}

.event-card-compact {
  position: absolute;
  width: 160px;
  min-height: 120px;
  z-index: 10;
  top: 0;
  transform: translate(150px, -45px);
}
.event-date-block {
  width: 100%;
  height: 36px;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.24);
  border-radius: 2px;
}
</style>
